import React from "react";
import IconGlyph from "./IconGlyph";

const SectionIcon = ({ section, small }) => (
  <span className={`estate-mapping__section-icon estate-mapping__section-icon--${section.tone}${small ? " estate-mapping__section-icon--small" : ""}`}>
    <IconGlyph name={section.icon} />
  </span>
);

export default SectionIcon;
